import Image from "next/legacy/image";
import { useRef } from "react";
import { useAtom } from "jotai";

import * as S from "./LandingPageSolutionMolecule.style";
import {
  useVisible,
  intersectingNumberAtom,
} from "@/businessLogics/_common/util-browser/useIntersection";
import { SolutionData } from "src/models/landing/solution/solution.model";

const LandingPageSolutionMolecule = ({
  onVisible,
  onInvisible,
  landingSolutionData,
}: {
  onVisible?: () => void;
  onInvisible?: () => void;
  landingSolutionData: SolutionData[];
}) => {
  const [intersectingNumber] = useAtom(intersectingNumberAtom);

  const ref_0 = useRef(null);
  const ref_1 = useRef(null);
  const ref_2 = useRef(null);
  const ref_3 = useRef(null);
  const ref_4 = useRef(null);
  const refSet = [ref_0, ref_1, ref_2, ref_3, ref_4];
  useVisible(ref_0, onVisible, onInvisible);
  useVisible(ref_1, onVisible, onInvisible);
  useVisible(ref_2, onVisible, onInvisible);
  useVisible(ref_3, onVisible, onInvisible);
  useVisible(ref_4, onVisible, onInvisible);
  return (
    <S.Wrapper>
      <S.Divider />
      {landingSolutionData.map((solution, idx) => (
        <S.Solution id={`${idx + 1}`} key={solution.number} ref={refSet[idx]}>
          <S.Step>
            <S.Number intersecting={+intersectingNumber === solution.number}>
              {solution.number}
            </S.Number>
            <S.Title>{solution.title}</S.Title>
          </S.Step>
          <S.MobileImage>
            <Image src={solution.img} alt="image" loading="lazy" />
          </S.MobileImage>
          <S.DesktopImage>
            <Image src={solution.img} alt="image" unoptimized loading="lazy" />
          </S.DesktopImage>
          <S.Desc>{solution.desc}</S.Desc>
        </S.Solution>
      ))}
    </S.Wrapper>
  );
};

export default LandingPageSolutionMolecule;
